module.exports = __webpack_public_path__ + "img/1-back-mobile.1b753fd0.jpg";